// src/components/LanguageSwitcher.jsx

import { useLanguage } from "../i18n/LanguageContext";

const LanguageSwitcher = ({ mobile = false }) => {
  const { language, setLanguage } = useLanguage();

  const languages = [
    { code: "ru", label: "RU" },
    { code: "en", label: "EN" }
  ];

  if (mobile) {
    return (
      <div className="d-flex gap-1 mt-2">
        {languages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => setLanguage(lang.code)}
            className="btn w-100"
            style={{
              fontSize: "0.875rem",
              padding: "0.5rem",
              background: "transparent",
              border: "none",
              color: language === lang.code ? "var(--color-accent)" : "var(--color-text-secondary)",
              fontWeight: language === lang.code ? 600 : 400,
              borderBottom: language === lang.code ? "2px solid var(--color-accent)" : "2px solid transparent",
              paddingBottom: "0.3rem"
            }}
          >
            {lang.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "0.25rem", marginLeft: "0.5rem" }}>
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => setLanguage(lang.code)}
          style={{
            padding: "0.375rem 0.5rem",
            backgroundColor: "transparent",
            color: language === lang.code ? "var(--color-accent)" : "var(--color-text-secondary)",
            border: "none",
            borderRadius: "0",
            cursor: "pointer",
            fontSize: "0.8125rem",
            fontWeight: language === lang.code ? 600 : 400,
            transition: "all 0.2s",
            display: "flex",
            alignItems: "center",
            gap: "0.25rem",
            borderBottom: language === lang.code ? "2px solid var(--color-accent)" : "2px solid transparent",
            paddingBottom: "0.3rem"
          }}
          title={lang.code === "ru" ? "Русский" : "English"}
        >
          <span>{lang.label}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
